import { render, staticRenderFns } from "./ShopCategoryList.vue?vue&type=template&id=aeba1aa8&scoped=true&"
import script from "./ShopCategoryList.vue?vue&type=script&lang=js&"
export * from "./ShopCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./ShopCategoryList.vue?vue&type=style&index=0&id=aeba1aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeba1aa8",
  null
  
)

export default component.exports